import { render, staticRenderFns } from "./ProductCategoryOptionsSimpleTable.vue?vue&type=template&id=efb493bc&scoped=true&"
import script from "./ProductCategoryOptionsSimpleTable.vue?vue&type=script&lang=ts&"
export * from "./ProductCategoryOptionsSimpleTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCategoryOptionsSimpleTable.vue?vue&type=style&index=0&id=efb493bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb493bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VIcon,VSimpleTable,VTextField,VTooltip})
